import React from "react";
import { MapPin } from "lucide-react";
import { useT } from "../i18n/LanguageContext";

const POSTS = [
  { city: "Miami", region: "Florida, USA", code: "MIA", desc_key: "miami_desc", address: "8200 NW 27th St, Doral, FL 33122" },
  { city: "Montréal", region: "Québec, Canada", code: "YUL", desc_key: "montreal_desc", address: "9500 Boulevard St-Laurent, Montréal QC" },
  { city: "Santiago", region: "República Dominicana", code: "STI", desc_key: "santiago_desc", address: "Av. 27 de Febrero, Santiago de los Caballeros" },
  { city: "Port-au-Prince", region: "Haïti", code: "PAP", desc_key: "pap_desc", address: "Boulevard Toussaint Louverture, Tabarre" },
];

const POST_DESCRIPTIONS = {
  miami_desc: {
    ht: "Pòs Atlantik prensipal nou. Frè lanmè pou Pòtoprens chak Madi.",
    en: "Our flagship Atlantic post. Sea freight to Port-au-Prince every Tuesday.",
    fr: "Notre comptoir atlantique phare. Fret maritime vers Port-au-Prince chaque mardi.",
    es: "Nuestro puesto atlántico principal. Flete marítimo a Puerto Príncipe cada martes.",
    pt: "Nosso posto atlântico principal. Frete marítimo para Porto Príncipe toda terça.",
  },
  montreal_desc: {
    ht: "Sant nò pou dyaspora frankofòn. Kago ayè ak palèt.",
    en: "Northern hub serving the francophone diaspora. Air and palletized cargo.",
    fr: "Hub nordique au service de la diaspora francophone. Cargo aérien et palettisé.",
    es: "Centro norte para la diáspora francófona. Carga aérea y paletizada.",
    pt: "Hub nórdico para a diáspora francófona. Carga aérea e paletizada.",
  },
  santiago_desc: {
    ht: "Pòt Karayib teritoryal. Livrezon rapid nan fwontyè Ayiti.",
    en: "Caribbean overland gateway. Express delivery to the Haitian frontier.",
    fr: "Porte caribéenne terrestre. Livraison express jusqu'à la frontière haïtienne.",
    es: "Puerta caribeña terrestre. Entrega expresa a la frontera haitiana.",
    pt: "Portão terrestre do Caribe. Entrega expressa para a fronteira haitiana.",
  },
  pap_desc: {
    ht: "Tèminal souvren an. Livrezon final ak distribisyon nasyonal.",
    en: "The sovereign terminal. Final delivery and nationwide distribution.",
    fr: "Le terminal souverain. Livraison finale et distribution nationale.",
    es: "La terminal soberana. Entrega final y distribución nacional.",
    pt: "O terminal soberano. Entrega final e distribuição nacional.",
  },
};

export const TradingPosts = () => {
  const { t, locale } = useT();
  return (
    <section
      id="trading-posts"
      data-testid="trading-posts-section"
      className="relative bv-grain"
      style={{ background: "#0F1D14" }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
        <div className="text-center mb-16">
          <div className="text-[10px] tracking-[0.4em] uppercase text-[#D4AF37] mb-3 ornament">
            {t("posts.eyebrow")}
          </div>
          <h2 className="font-serif-bv text-4xl sm:text-5xl lg:text-6xl text-[#F5EFE0]">
            {t("posts.title_1")} <span className="italic text-[#D4AF37]">{t("posts.title_italic")}</span>
          </h2>
          <p className="text-[#F5EFE0]/70 mt-4 max-w-xl mx-auto">
            {t("posts.subtitle")}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {POSTS.map((p, i) => (
            <div
              key={p.code}
              data-testid={`trading-post-${p.code}`}
              className="border border-[#D4AF37]/30 hover:border-[#D4AF37] transition-all duration-300 p-8 lg:p-10 rounded-sm group bg-[#1B3022]/40 backdrop-blur-sm fade-up"
              style={{ animationDelay: `${0.1 * i}s` }}
            >
              <div className="flex items-start justify-between gap-4">
                <div>
                  <div className="text-[10px] tracking-[0.3em] uppercase text-[#D4AF37]/70 mb-2">
                    {t("posts.label")} {String(i + 1).padStart(2, "0")}
                  </div>
                  <div className="flex items-baseline gap-3">
                    <h3 className="font-serif-bv text-4xl lg:text-5xl text-[#D4AF37]">{p.city}</h3>
                    <span className="font-serif-bv text-xl text-[#F5EFE0]/40">{p.code}</span>
                  </div>
                  <div className="text-sm text-[#F5EFE0]/70 mt-1 italic">{p.region}</div>
                </div>
                <MapPin className="text-[#D4AF37] shrink-0 group-hover:scale-110 transition-transform" size={28} />
              </div>
              <div className="gold-divider mt-6 mb-6" />
              <p className="text-sm text-[#F5EFE0]/85 leading-relaxed">{POST_DESCRIPTIONS[p.desc_key][locale] || POST_DESCRIPTIONS[p.desc_key].en}</p>
              <p className="text-xs text-[#F5EFE0]/55 mt-4 tracking-wide">{p.address}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TradingPosts;
